
import React from 'react';
import {Button} from 'react-bootstrap';
import InputMask from 'react-input-mask';
import ReCAPTCHA from 'react-google-recaptcha';
// import DeParamMovingURL from '../common/DeParamMovingURL.js';

class ThirdStep extends React.Component {
  constructor(props) {
    super(props);

    // Setup save/read top component state
    this.saveTopState = props.saveTopState;
    this.readTopState = props.readTopState;

    // Reading state parameters from top state
    let savedFirstState = this.readTopState('firstStepState');
    let savedSecondState = this.readTopState('secondStepState');
    let savedThirdState = this.readTopState('thirdStepState');

    this.state = {
      firstStepState: savedFirstState.movingFromAddress ? savedFirstState : {
        "movingFromAddress":{"value":{"lat":28.8240644,"lng":-81.3185346},"label":"Manhattan, New York, NY, USA","isValid":true,"cityAndState":{"city":"New York","state":"NY"}},"movingToAddress":{"value":{"lat":31.05679419999999,"lng":-89.18937199999999},"label":"Brooklyn, MS 39425, USA","isValid":true,"cityAndState":{"city":"Brooklyn","state":"MS"}},"movingFromFlights":{"value":"2","label":"2nd floor walk up"},"movingToFlights":{"value":"0","label":"Ground floor"},"moveSize":{"value":"1","label":"Studio or Partial Apartment"},"movingDate":"2018-11-24","errorclass":"before-error-validation","distance":9,"isValid":false
      },
      secondStepState: savedSecondState.packingOption ? savedSecondState : {
        "items":{"Living Room":{"name":"Living Room","elements":{"TV flat 21''-42''":{"name":"TV flat 21''-42''","quantity":4,"volume":10}}}},"totalVolume":40,"customItems":{},"customItemIndex":0,"packingOption":{"value":"1","label":"Option 1 - Economy"},"referrence":{"value":"2","label":"Used DUMBO before / Repeat Customer"},"volumeErrorMsg":"hide-error-msg","customItemsErrorMsg":"hide-error-msg"

      },
      allHourlyRate : savedThirdState.allHourlyRate ? savedThirdState.allHourlyRate : {},
      theitems: savedThirdState.itemsformail,
      moveDetails: {prices: {}},
      prices: {},
      datePrices: {},
      binsNumber: savedThirdState.binsNumber,
      wardrobeNumber: savedThirdState.wardrobeNumber,
      yourName: savedThirdState.yourName ? savedThirdState.yourName : { isFieldValid : false },
      yourLastName: savedThirdState.yourLastName ? savedThirdState.yourLastName : { isFieldValid : false },
      yourEmail: savedThirdState.yourEmail ? savedThirdState.yourEmail : { isFieldValid : false },
      yourPhone: savedThirdState.yourPhone ? savedThirdState.yourPhone : { isFieldValid : false },
      newDate : savedThirdState.newDate ? savedThirdState.newDate :  this.readTopState('firstStepState').movingDate,
      theitemsfront: savedThirdState.theitemsfront || {"Living Room":{"name":"Living Room","elements":{"TV flat 21''-42''":{"name":"TV flat 21''-42''","quantity":4,"volume":10}}}},
      errorclass: "",
      theDeposit: savedThirdState.theDeposit,
      priceRange : savedThirdState.priceRange ? savedThirdState.priceRange : "",
      hourlyRatesDaily : savedThirdState.hourlyRatesDaily ? savedThirdState.hourlyRatesDaily : "",
      manPower : savedThirdState.manPower ? savedThirdState.manPower : "",
      theDiclaimer: savedThirdState.theDiclaimer || {checked: false, value:"No"},
      theRange: savedThirdState.theRange || 0,
      noDoubleSubmit: false,
      recaptchaToken: null, // Add reCAPTCHA token state
      recaptchaRef: null, // Add reCAPTCHA ref
      utmParams: this.readTopState('utmParams') || {} // Get UTM params from top state
    };

    // Binding methods
    this.changePacking = this.changePacking.bind(this);
    this.changeDate = this.changeDate.bind(this);
    // this.getItems = this.getItems.bind(this);
    this.onInputFieldChange = this.onInputFieldChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.onRecaptchaChange = this.onRecaptchaChange.bind(this); // Add reCAPTCHA change handler
    this.recaptchaRef = React.createRef(); // Create ref for reCAPTCHA

  }
/**
 * On component mount send data to server and get calculated price
 * @return {[type]} [description]
 */
  componentDidMount() { 

    // Debug: Log UTM params on mount
    console.log('[QC UTM DEBUG] ThirdStep mounted - UTM params:', this.state.utmParams);
    
    // Also try to get from top state if not in local state
    if (!this.state.utmParams || Object.keys(this.state.utmParams).length === 0) {
      const topUTM = this.readTopState('utmParams');
      if (topUTM && Object.keys(topUTM).length > 0) {
        console.log('[QC UTM DEBUG] Loading UTM params from top state:', topUTM);
        this.setState({ utmParams: topUTM });
      }
    }

    // this.getItems();
    // Combine all relevant state data into one object
    let firstStepState = this.state.firstStepState;
    let secondStepState = this.state.secondStepState;
   
    let newDate = new Date(this.state.firstStepState.movingDate);
    let fullNewDate = newDate.getDate() + "-" + ("0" + (newDate.getMonth() + 1)).slice(-2) + "-" + newDate.getFullYear()
    console.log("datee", fullNewDate);
    // let distance = this.readTopState('distance');

      let wardrobeNumber = 0;
      let binsNumber = 0;

      let theobject = secondStepState['items'];

      console.log(theobject);
       let itemsformail = [];
       // let roomNames = [];
       let roomName = "";
       let allCurrentRooms = ['Bedroom(s)', 'Kitchen', 'Office', 'Patio & Outdoor', 'Oversized/Heavy Items', 'Living Area(s)', 'Custom Items', 'Boxes or Containers', 'Miscellaneous Containers', 'Appliances', 'Garage'];


      for (var key in theobject){
        if (theobject.hasOwnProperty(key)){
          let firstloop = theobject[key];
          for (var key2 in firstloop){
            if (firstloop.hasOwnProperty(key2)){
                  let secondloop = firstloop[key2];                
                if (!allCurrentRooms.includes(secondloop) ) {
                  for (var key3 in secondloop){
                    if (secondloop.hasOwnProperty(key3)){
                      let thirdloop = secondloop[key3];
                        itemsformail.push(roomName + [thirdloop.name + ' x ' + thirdloop.quantity]);                   
                  }
                }
              }
            }
          }
        }
      }

  

    itemsformail = itemsformail.join('; ');

    let userInput = {
      'wardrobeNumber': wardrobeNumber,
      'binsNumber': binsNumber,
      'cityStateFrom': firstStepState['movingFromAddress']['cityAndState'],
      'cityFrom': firstStepState['movingFromAddress']['cityAndState']['city'],
      'postalFrom': firstStepState['movingFromAddress']['searchFromPostalCode'],
      'streetAddressFrom': firstStepState['movingFromAddress']['streetAddress'],
      'cityStateTo': firstStepState['movingToAddress']['cityAndState'],
      'cityTo': firstStepState['movingToAddress']['cityAndState']['city'],
      'postalTo': firstStepState['movingToAddress']['searchToPostalCode'],
      'streetAddressTo': firstStepState['movingToAddress']['streetAddress'],
      'date': firstStepState['movingDate'],
      'directDistance': firstStepState['pickupToDelivery']['distance'],
      'longestDistance': firstStepState['longestDistance'],
      'pickupState': firstStepState['pickupState'],
      'deliveryState': firstStepState['deliveryState'],
      'baseToDelivery': firstStepState['baseToDelivery']['distance'],
      'baseToPickup': firstStepState['baseToPickup']['distance'],
      'travelDuration': firstStepState['travelDuration'],
      'floorFrom': firstStepState['movingFromFlights'].value,
      'floorTo':   firstStepState['movingToFlights'].value,
      'frontCf': secondStepState['totalVolume'],
      'packaging': secondStepState['packingOption'].label,
      'tempuraPedic': secondStepState['tempuraPedic'].value,
      'tempuraPedicQty': secondStepState['tempuraPedic'].qty,
      'rentBoxesQty': secondStepState['rentBoxes'].qty,
      'rentBoxes': secondStepState['rentBoxes'].value,
      'travelDurationBP' : firstStepState['travelDurationBP'],
      'travelDurationDB' : firstStepState['travelDurationDB'],
      'travelDurationPD' : firstStepState['travelDurationPD'],
      'moveTypeFrom' : firstStepState['movingFromElevator'].label,
      'moveTypeTo' : firstStepState['movingToElevator'].label,
      'packingHouseSize' : secondStepState['packingHouseSize']['value'],
      'walkUp' : secondStepState['walkUp']['value'],
      'addItemPrice' : secondStepState['addItemPrice'],
      'storageOption' : secondStepState['storageOption']['value'],
      'referrence': {
        'name': secondStepState['referrence'].label,
        'type': secondStepState['referrence'].value,
      },
    }
    console.log("userInput" , userInput);

    //Send combined data to the server for calculation
    fetch('/wp-json/qc/v1/calculate', {
      method: 'POST',
      headers: {
        'Accept': 'application/json; charset=UTF-8',
        'Content-Type': 'application/json; charset=UTF-8',
      },
      body: JSON.stringify({
        "user_input": JSON.stringify(userInput)
      })
    })
    .then(res => res.json())
    .then(
      (result) => {

        //Prepare output for state
        let moveDetails = JSON.parse(result);
        console.log(moveDetails);
        // Get all pricess
        let prices = JSON.parse(moveDetails.prices);
        let range = JSON.parse(moveDetails.priceRange);
        let allHourlyRate = JSON.parse(moveDetails.hourly_rates_daily);
        let hourlyRatesDaily = allHourlyRate[this.state.firstStepState.movingDate];
        let manPower = JSON.parse(moveDetails.number_of_workers);

        // Get prices for different packing options for selected move date
        let datePrices = (prices[this.state.firstStepState.movingDate] !== undefined) ? prices[this.state.firstStepState.movingDate] : (prices[this.state.firstStepState.movingDate] === "TBD") ? prices[this.state.firstStepState.movingDate] :  {1: "Selected date is not available, please choose another one", 2: "Selected date is not available, please choose another one"};

        console.log("prices", prices);
        console.log("prices", datePrices);

        // Get price for date and selected packing option
        let datePackingPrice = (datePrices !== undefined) ? datePrices[this.state.secondStepState.packingOption.value] : "TBD";

        let priceRange = (datePrices !== undefined || datePrices !== 'TBD') ? '$' + (datePackingPrice - range) + ' - $' +  (datePackingPrice + range) : "TBD";
          
        console.log(hourlyRatesDaily, "hourlyRatesDaily");
        console.log(manPower, "manPower");

        let theDeposit = moveDetails.deposit;

        this.setState({
          isLoaded: true,
          moveDetails: moveDetails,
          datePrices: datePrices,
          datePackingPrice: datePackingPrice,
          prices: prices,
          theitems: itemsformail,
          binsNumber: binsNumber,
          wardrobeNumber: wardrobeNumber,
          theDeposit: theDeposit,
          newDate : fullNewDate,
          priceRange : priceRange,
          hourlyRatesDaily : hourlyRatesDaily,
          manPower : manPower,
          allHourlyRate : allHourlyRate,
          theRange: range

        });
      },

      (error) => {
        this.setState({
          isLoaded: true,
          error
        }, () => console.log(error));
      }
    );

  }

  handleCheckboxChange (event) {

    let { name, value } = event.target;

    let tempura = "No";

    if(event.target.checked === true){
      tempura = "Yes";
    }

      // Saving to state
    this.setState({
        [name] : {
          'value' : tempura,
          'checked' : event.target.checked
        },
    }, ()=> console.log(this.state));

  }

  /**
   * Handle reCAPTCHA token change
   * @param  {string} token reCAPTCHA token
   * @return {void}
   */
  onRecaptchaChange(token) {
    console.log('[QC reCAPTCHA DEBUG] reCAPTCHA token received:', token ? token.substring(0, 20) + '...' : 'null');
    this.setState({
      recaptchaToken: token
    });
  }


 /**
   * Method for getting the items for front view 
   * @param  {[type]} option [description]
   * @param  {[type]} event  [description]
   * @return {[type]}        [description]
   */
changePacking (option, event) {

    event.preventDefault();

     let firstStepState = this.state.firstStepState;
    // Set variables for secondStepState and
    let secondStepState = this.state.secondStepState;
    let newPackingLabel = '';


    // Define label based on selected option
    switch(parseInt(option, 10)){
      case(1):
      newPackingLabel = 'No Packing';
      break;
      case(2):
      newPackingLabel = 'Standard Packing';
      break;
    }


    // Prepare values for saving in state
    secondStepState.packingOption.value = parseInt(option, 10);
    secondStepState.packingOption.label = newPackingLabel;
    let datePackingPrice = this.state.prices[firstStepState.movingDate][parseInt(option, 10)];
    let priceRange = (this.state.prices[firstStepState.movingDate][parseInt(option, 10)] !== undefined || this.state.prices[firstStepState.movingDate][parseInt(option, 10)] !== 'TBD' ) ? '$' + (datePackingPrice - this.state.theRange) + ' - $' +  (datePackingPrice + this.state.theRange) : "TBD";
    // Save new values to state
    this.setState({
      secondStepState: secondStepState,
      datePackingPrice: datePackingPrice,
      priceRange : priceRange
    }, () => console.log(this.state.datePackingPrice))

  }


  /**
   * Method for changing packing and saving current price based on new packing option
   * @param  {[type]} option [description]
   * @param  {[type]} event  [description]
   * @return {[type]}        [description]
   */
  // getItems () {

  //   // Set variables for secondStepState and
  //   let secondStepState = this.state.secondStepState;

  //   let theobject = secondStepState['items'];

  //   let theitemsfront = {}
  //   var props = Object.keys(theitemsfront);
  //     for (var i = 0; i < props.length; i++) {
  //       delete theitemsfront[props[i]];
  //   }

    

  //   // Save new values to state
  //   this.setState({
  //     theitemsfront: theitemsfront
  //   }, () => console.log(this.state.theitemsfront))

  // }


  /**
   * Method for changing date and saving current price based on new date
   * @param  {[type]} date  [description]
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  changeDate (date, event){

    
    event.preventDefault();

    // Prepare variables
    let datePackingPrice = this.state.prices[date][this.state.secondStepState.packingOption.value];

    let priceRange = (this.state.prices[date][this.state.secondStepState.packingOption.value] !== undefined || this.state.prices[date][this.state.secondStepState.packingOption.value] !== 'TBD') ? '$' + (datePackingPrice - this.state.theRange) + ' - $' +  (datePackingPrice + this.state.theRange) : "TBD";

    let firstStepState = this.state.firstStepState;
    firstStepState.movingDate = date;
    let hourlyRatesDaily = this.state.allHourlyRate[date];

    // Saving variables
    this.setState({
      datePackingPrice: datePackingPrice,
      firstStepState: firstStepState,
      hourlyRatesDaily: hourlyRatesDaily,
      priceRange : priceRange

    })

  }


  /**
   * Method for validating and saving input fields
   * @param  {[type]} event input field that is changing
   * @return {[type]}       adding or removing error class
   */
  onInputFieldChange(event) {

    // Prepare variables
    let { name, value } = event.target;
    let isFieldValid = false;

    // Creating validation cases
    switch(name){
      case 'yourName':
        isFieldValid = ( value.length > 2 ) ? true : false;
      break;
      case 'yourLastName':
        isFieldValid = ( value.length > 2 ) ? true : false;
      break;
      case'yourEmail':
        isFieldValid = ( value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ) ? true : false;
      break;
      case 'yourPhone':
        isFieldValid = ( value.match(/^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/) ) ? true : false;
      break;
    }

    // Saving to state
    this.setState({
        [name] : {
          'value' : value,
          'isFieldValid' : isFieldValid
        },
    });
    event.target.className = ( isFieldValid ? 'input-valid' : 'input-error' );
  }


  /**
   * Going to previous step
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleBack (event) {

   event.preventDefault();
   const calcFormAnchor = ( window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);

    // Saving current state and going to previous step
    const activeStep = this.readTopState('activeStep');
    this.saveTopState({
      activeStep: activeStep - 1,
      thirdStepState: {
          yourName : this.state.yourName,
          yourLastName : this.state.yourLastName,
          yourEmail : this.state.yourEmail,
          yourPhone : this.state.yourPhone,
      },
      firstStepState: this.state.firstStepState,
      secondStepState: this.state.secondStepState,
     }, ()=> window.scrollTo(0, calcFormAnchor) );

  }


  /**
   * Validating all fields and sending data to server if everything checks out
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleSubmit (event) {

    event.preventDefault();

    // Debug: Log form submission attempt
    console.log('[QC reCAPTCHA DEBUG] Form submission attempted');
    console.log('[QC reCAPTCHA DEBUG] reCAPTCHA token present:', !!this.state.recaptchaToken);

    // If all fields from step 3 are valid
    if( this.state.yourName.isFieldValid && this.state.yourLastName.isFieldValid && this.state.yourEmail.isFieldValid && this.state.yourPhone.isFieldValid && this.state.theDiclaimer.checked === true && this.state.noDoubleSubmit === false){
      
      // Check if reCAPTCHA token is present
      if (!this.state.recaptchaToken) {
        console.log('[QC reCAPTCHA DEBUG] reCAPTCHA token missing - blocking submission');
        alert('Please complete the reCAPTCHA verification before submitting.');
        if (this.recaptchaRef.current) {
          this.recaptchaRef.current.reset();
        }
        return;
      }

      this.setState({
        noDoubleSubmit: true
      });
      document.getElementById('submit-loading').style.display = 'block';

    //Preparing variables to be used for sending
     let firstStepState = this.state.firstStepState;
    let secondStepState = this.state.secondStepState;

      // Debug: Log payload before sending
      console.log('[QC reCAPTCHA DEBUG] Preparing to send quote data with reCAPTCHA token');
      console.log('[QC UTM DEBUG] UTM parameters being sent:', this.state.utmParams);

      //Send data to the server for getting quote and email sending
      fetch('/wp-json/qc/v1/quotes', {
        method: 'POST',
        headers: {
          // 'Accept': 'application/json; charset=UTF-8',
          'Content-Type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          addressFrom: firstStepState['movingFromAddress'].label,
          cityFrom: firstStepState['movingFromAddress']['cityAndState']['city'],
          postalFrom: firstStepState['movingFromAddress']['searchFromPostalCode'],
          streetAddressFrom: firstStepState['movingFromAddress']['streetAddress'],
          addressTo: firstStepState['movingToAddress'].label,
          cityTo: firstStepState['movingToAddress']['cityAndState']['city'],
          postalTo: firstStepState['movingToAddress']['searchToPostalCode'],
          streetAddressTo: firstStepState['movingToAddress']['streetAddress'],
          cf: secondStepState['totalVolume'],
          date: firstStepState['movingDate'],
          floorFrom: firstStepState['movingFromFlights'].label,
          floorTo: firstStepState['movingToFlights'].label,
          moveTypeFrom: firstStepState['movingFromElevator'].label,
          moveTypeTo: firstStepState['movingToElevator'].label,
          packaging: secondStepState['packingOption'].label,
          price: this.state.datePackingPrice,
          directDistance: firstStepState['pickupToDelivery']['distance'],
          name: this.state.yourName.value,
          lastname: this.state.yourLastName.value,
          email:this.state.yourEmail.value,
          phone:this.state.yourPhone.value,
          allItemsForMoving: this.state.theitems,
          referrence: secondStepState['referrence'].label,
          smallBinsNumber : this.state.binsNumber,
          mediumBinsNumber : this.state.binsNumber,
          largeBinsNumber : this.state.binsNumber,
          wardrobeBoxNumber : this.state.wardrobeNumber,
          longestDistance: firstStepState['longestDistance'],
          deliveryState: firstStepState['deliveryState'],
          pickupState: firstStepState['pickupState'],
          tempuraPedic : secondStepState['tempuraPedic'].qty,
          rentBoxes : secondStepState['rentBoxes'].qty,
          theDeposit : this.state.theDeposit,
          packingHouseSize : secondStepState['packingHouseSize'].value,
          priceRange : this.state.priceRange,
          hourlyRatesDaily : this.state.hourlyRatesDaily,
          manPower : this.state.manPower,
          walkUp : secondStepState['walkUp'].value,
          storageOption : secondStepState['storageOption'].value,
          recaptcha_token: this.state.recaptchaToken, // Add reCAPTCHA token to payload
          utm_source: this.state.utmParams.utm_source || '', // Add UTM parameters
          utm_medium: this.state.utmParams.utm_medium || '',
          utm_campaign: this.state.utmParams.utm_campaign || '',
          utm_term: this.state.utmParams.utm_term || '',
          gclid: this.state.utmParams.gclid || ''
        })
      })
      .then(res => {
        console.log('[QC reCAPTCHA DEBUG] Response status:', res.status);
        return res.json();
      })
      .then(
        (result) => {
          console.log('[QC reCAPTCHA DEBUG] Quote submission result:', result);
          if (result.code && result.message) {
            // Handle error response
            console.error('[QC reCAPTCHA DEBUG] Error from server:', result.message);
            alert('Submission failed: ' + result.message);
            this.setState({
              noDoubleSubmit: false
            });
            document.getElementById('submit-loading').style.display = 'none';
            // Reset reCAPTCHA on error
            if (this.recaptchaRef.current) {
              this.recaptchaRef.current.reset();
              this.setState({ recaptchaToken: null });
            }
          } else {
            window.location = '/qc-thank-you/';
          }
        },

        (error) => {
          console.error('[QC reCAPTCHA DEBUG] Fetch error:', error);
          this.setState({
            noDoubleSubmit: false
          });
          document.getElementById('submit-loading').style.display = 'none';
          // Reset reCAPTCHA on error
          if (this.recaptchaRef.current) {
            this.recaptchaRef.current.reset();
            this.setState({ recaptchaToken: null });
          }
        }
      );

    }
    // If else throw an error class
    else {
      this.setState({
        errorclass: 'input-error'
      });
    }

  }

render() {
  console.log(this.state.theitems, "this.state.theitemsfront");

  return (
    <div className="qc-third-step">
      <div className="md-quote-info">
        <p className="move-date"><strong>Date of Move:</strong> {this.state.newDate} </p>
        <p className="moving-from-address"><strong>Pickup Address:</strong> {this.state.firstStepState.movingFromAddress.label} </p>
        <p className="elevator-from"><strong>Moving From Floor:</strong> {this.state.firstStepState.movingFromFlights.label} </p>
        <p className="moving-to-address"><strong>Delivery address:</strong> {this.state.firstStepState.movingToAddress.label} </p>
        <p className="elevator-to"><strong>Moving to Floor:</strong> {this.state.firstStepState.movingToFlights.label} </p>
        <p className="elevator-to"><strong>Pounds:</strong> {this.state.secondStepState.totalVolume * 7} lbs</p>
        <p className="elevator-to"><strong>Items for Moving: </strong>

         {this.state.theitems}
          
        </p>
        <p className="packing-option"><strong>Packaging:</strong> {this.state.secondStepState.packingOption.label} </p>
        <p className="packing-option"><strong>Your price:</strong>  $ {
          this.state.datePackingPrice ? this.state.datePackingPrice : 'It is loading'
        }<span  className={ (this.state.datePackingPrice === "TBD") ?  "hidden" : "fire-deposit"}><strong> Booking fee</strong>: ${this.state.theDeposit}</span></p>
       <p className={ (this.state.datePackingPrice === "TBD" || this.state.datePackingPrice === 'Selected date is not available, please choose another one') ?  "hidden" : "react-disclaimer"}>*This is an estimated price which can range from ({this.state.priceRange}). Our Moving Consultant will be able to give you the most accurate estimate after discussing the move with you.</p>
        <p className="elevator-to"><strong>Hourly Rate and Man Power:</strong> {this.state.manPower} men - ${this.state.hourlyRatesDaily} per hour </p>

        <p className={ this.state.datePackingPrice === 'Selected date is not available, please choose another one'  ?  'hidden' : 'alternative-packing'}><strong>Alternative Packaging Option Prices:</strong><br/> 
        {
               Object.entries(this.state.datePrices).map( option =>
                 <span className="new-packing-price-wrap" style={this.state.secondStepState.packingOption.value === option[0] ? {display:'none'} : {}}>
                <div className="new-packing-price">Packing price: ${this.state.prices[this.state.firstStepState.movingDate][option[0]]} </div>
               <button value="CHANGE" onClick={(event) => this.changePacking(option[0], event)} >
                {(option[0] === "1") ? "No Packing " : "Standard Packing"}

               </button><br></br></span>
           ) }
          </p>
      </div>
       <div>
        <h3 class="md-center">Please fill your personal information:</h3>
          <div className="md-moving-full-2">
            <input type="text" id="yourName" name="yourName" placeholder="First Name"
              defaultValue={this.state.yourName.value}
              className={ !this.state.yourName.isFieldValid ? this.state.errorclass : "untouched" }
              onChange={this.onInputFieldChange} />
          </div>
          <div className="md-moving-full-2">
            <input type="text" id="yourLastName" name="yourLastName" placeholder="Last Name"
              defaultValue={this.state.yourLastName.value}
              className={ !this.state.yourLastName.isFieldValid ? this.state.errorclass : "untouched" }
              onChange={this.onInputFieldChange} />
          </div>

          <div className="md-moving-full-2">
            <input type="text" id="yourEmail" name="yourEmail" placeholder="Email"
              defaultValue={this.state.yourEmail.value}
              className={ !this.state.yourEmail.isFieldValid ? this.state.errorclass : "untouched" }
              onChange={this.onInputFieldChange} />
          </div>
          <div className="md-moving-full-2">
            <InputMask type="text" id="yourPhone" name="yourPhone" placeholder="Phone"
              mask="(999) 999-9999"
              maskChar=" "
              defaultValue={this.state.yourPhone.value}
              value={this.state.yourPhone.value}
              className={ !this.state.yourPhone.isFieldValid ? this.state.errorclass : "untouched" }
              onChange={this.onInputFieldChange} />
          </div>

           <div className="checkbox-wrapper">
                    <div class="real-checkobx-wrapper">
                      <input type="checkbox"  className={ this.state.theDiclaimer.checked === false ? this.state.errorclass : "untouched" } id="theDiclaimer" checked={this.state.theDiclaimer.checked} data-qty="0" onChange={this.handleCheckboxChange} name="theDiclaimer" required />
                    </div>
                    <label htmlFor="theDiclaimer">
                        <span>This calculator is designed to give you an estimate. The ultimate price for your move will depend on the amount of time and services used and the price from this calculator should not be considered a proposal or set price. For the most accurate estimate, a brief conversation with one of our Moving Consultants is highly recommended. <strong>A move will not be considered booked until speaking to a consultant to verify information and a booking fee is collected.</strong></span>
                    </label>
            </div>

            {/* Add hidden UTM parameter fields for form submission */}
            <div style={{display: 'none'}}>
              <input type="hidden" name="utm_source" value={this.state.utmParams.utm_source || ''} />
              <input type="hidden" name="utm_medium" value={this.state.utmParams.utm_medium || ''} />
              <input type="hidden" name="utm_campaign" value={this.state.utmParams.utm_campaign || ''} />
              <input type="hidden" name="utm_term" value={this.state.utmParams.utm_term || ''} />
              <input type="hidden" name="gclid" value={this.state.utmParams.gclid || ''} />
            </div>


            {/* Add reCAPTCHA component */}
            <div className="recaptcha-wrapper" style={{margin: '20px 0'}}>
              {(typeof window !== 'undefined' && window.pluginInfo && window.pluginInfo.recaptcha_site_key) ? (
                <ReCAPTCHA
                  ref={this.recaptchaRef}
                  sitekey={window.pluginInfo.recaptcha_site_key}
                  onChange={this.onRecaptchaChange}
                  onExpired={() => {
                    console.log('[QC reCAPTCHA DEBUG] reCAPTCHA expired');
                    this.setState({ recaptchaToken: null });
                  }}
                  onError={(error) => {
                    console.error('[QC reCAPTCHA DEBUG] reCAPTCHA error:', error);
                    this.setState({ recaptchaToken: null });
                  }}
                />
              ) : (
                <div style={{color: 'red', padding: '10px'}}>
                  [DEBUG] reCAPTCHA site key not configured. Please set it in WordPress admin under Quotes > reCAPTCHA Settings.
                </div>
              )}
            </div>

          <div className='steps-navigation btn-x-2'>
            <div className="vm-prev-btn">
              <img alt="spinner" style={{display: 'none'}} id="submit-loading" src="/wp-content/plugins/quote-calculator-r/assets/img/spin-submit.svg" />
              <Button type='submit' onClick={this.handleBack}>Previous</Button>
            </div>
            <div className="sec-next-btn">
              <Button type='submit' onClick={this.handleSubmit}>Submit</Button>
            </div>
          </div>

      </div>


       <div className="alternative-dates">

         <div><strong>Alternative Date Prices:</strong></div>
         <div class="alternative-dates-inner">
         {
             Object.entries(this.state.prices).map( date =>
                    <div className={this.state.firstStepState.movingDate === date[0] ? 'selected-date qc-date' : 'not-selected qc-date'}>
                 <span className="qc-suggested-date">{ date[0] } <br /></span>
                  <span className="qc-suggested-price">${ date[1][this.state.secondStepState.packingOption.value] }<br/></span>
                 <button value="CHANGE"
                   onClick={(event) => this.changeDate(date[0], event)}
                   style={this.state.firstStepState.movingDate === date[0] ? { display: 'none' } : { display: 'block' }}>
                   Select
                 </button>
                 <span className="qc-picked-option" style={this.state.firstStepState.movingDate === date[0] ? { display: 'block' } : { display: 'none' }}>
                 Selected</span>
                 </div>

         ) }
       </div> </div>


    </div>
  );
}
}

export default ThirdStep;



// WEBPACK FOOTER //
// ./src/steps/ThirdStep.js